/* eslint-disable no-useless-catch */
import { summaryTask, summaryTaskType } from 'api/mdl07'

export const getTaskTypesAction = () => async () => {
  try {
    const response = await summaryTaskType()
    const { data, status } = response
    if (status === 200 && data?.Data) {
      return response
    }
  } catch (err) {
    throw err
  }
}

export const fetchSummaryTask = payload => async () => {
  try {
    const response = await summaryTask(payload)
    const { data, status } = response
    if (status === 200 && data?.Data) {
      return response
    }
  } catch (err) {
    throw err
  }
}
